import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { ButtonLinkComponent } from '../../buttons/button-link/button-link.component';

@Component({
  selector: 'mwe-flipping-content',
  templateUrl: './flipping-content.component.html',
  imports: [NgClass, ButtonLinkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlippingContentComponent {
  readonly frontCardLabel = input<string>('');
  readonly frontCardAriaLabel = input<string>('');
  readonly backCardLabel = input<string>('');
  readonly backCardAriaLabel = input<string>('');

  readonly isFlipped = signal(false);
  readonly hadUserInteraction = signal<boolean>(false);

  readonly flipBtnLabel = computed(() => (this.isFlipped() ? this.backCardLabel() : this.frontCardLabel()));
  readonly flipBtnAriaLabel = computed(() => (this.isFlipped() ? this.backCardAriaLabel() : this.frontCardAriaLabel()));
  readonly prependIconClass = computed(() => (this.isFlipped() ? 'fas fa-chevron-left' : ''));
  readonly appendIconClass = computed(() => (this.isFlipped() ? '' : 'fas fa-chevron-right'));

  flip(): void {
    this.hadUserInteraction.set(true);
    this.isFlipped.update(value => !value);
  }
}
